import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeJourneyScaleEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export type EmployeeJourneyScaleType =
  | EmployeeJourneyScaleEnum.DAY
  | EmployeeJourneyScaleEnum.MONTH
  | EmployeeJourneyScaleEnum.WEEK;

export const EmployeeJourneyScaleArray = [
  EmployeeJourneyScaleEnum.DAY,
  EmployeeJourneyScaleEnum.MONTH,
  EmployeeJourneyScaleEnum.WEEK,
];

export const EmployeeJourneyScaleInfo: QarepaEnumInformation<EmployeeJourneyScaleEnum> =
  {
    [EmployeeJourneyScaleEnum.DAY]: {
      name: $localize`Día`,
    },
    [EmployeeJourneyScaleEnum.MONTH]: {
      name: $localize`Mes`,
    },
    [EmployeeJourneyScaleEnum.WEEK]: {
      name: $localize`Semanal`,
    },
  };
